import Utils from '../utils/Utils.js';

const Config = {
    onChange: new Phaser.Signal(),

    get ORIENTATION()
    {
        return this._ORIENTATION || '';
    },
    set ORIENTATION(value)
    {
        let name = 'ORIENTATION';
        let oldValue = this._ORIENTATION;
        let newValue = this._ORIENTATION = value;
        this.onChange.dispatch(name, newValue, oldValue);
    },

    get currentStake()
    {
        return this._currentStake || 0;
    },

    set currentStake(value)
    {
        this._currentStake = Math.round(100 * value) / 100;
    },

    get layout()
    {
        if (Config.MobileDevice && Config.GAME_WIDTH >= Config.GAME_HEIGHT)
        {
            return Config.LANDSCAPE;
        }
        else if (Config.MobileDevice && Config.GAME_WIDTH <= Config.GAME_HEIGHT)
        {
            return Config.PORTRAIT;
        }

        return Config.DESKTOP;
    }
};


// operator
Config.operatorId = '1000';
Config.token = '1000';
Config.vendor = 'Rocabee';
Config.balance = 0;
Config.CURRENCY = {
    prefix: '$',
    suffix: '',
    code: 'USD',
    exchangeRate: 1, // rate for transform to base currency USD/EUR/something else
    groupingSeparator: ',',
    decimalSeparator: '.',
    decimalPlaces: 2
};

Config.version = 'v1.4';

Config.soundEnabled = true;
Config.soundVolume = 1;
Config.musicEnabled = true;
Config.musicVolume = 0.5;

Config.alwaysTurbo = false;

// layout resolutions
// desktop
Config.DESKTOP_GAMEWIDTH = 1024;
Config.DESKTOP_GAMEHEIGHT = 683;
// landscape
Config.LANDSCAPE_GAMEWIDTH = 1024;
Config.LANDSCAPE_GAMEHEIGHT = 576;
// portrait
Config.PORTRAIT_GAMEWIDTH = 576;
Config.PORTRAIT_GAMEHEIGHT = 1024;

// gameplay
Config.GAME_WIDTH = Config.DESKTOP_GAMEWIDTH;
Config.GAME_HEIGHT = Config.DESKTOP_GAMEHEIGHT;
Config.MULTIPLAYER = false;
Config.FREE_PLAY = true;
Config.backgroundColor = '#660000';
Config.AUTOPICK = 15;
Config.MAX_SELECTED_NUMBERS = 15;
Config.DEFAULT_STAKE = 1;
Config.MAX_STAKE_PER_ROUND = 500;
Config.MIN_STAKE_PER_ROUND = 0.20;
Config.BET_VALUES = [0.01, 0.05, 0.25, 0.5, 1, 5,10,25,50,100,500,1000]; // deprecated: see GameModel.availableStakes
Config.NUMBER_OF_LINES = 25;
Config.BIGWIN_MULTIPLIER = 10;

// define view layout
Config.MobileDevice = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));

Config.DESKTOP = 'desktop';
Config.PORTRAIT = 'portrait';
Config.LANDSCAPE = 'landscape';
Config.START_ORIENTATION = '';
Config.ORIENTATION = Config.MobileDevice ? ( (Config.GAME_WIDTH > Config.GAME_HEIGHT) ? Config.LANDSCAPE : Config.PORTRAIT) : Config.DESKTOP;

Config.isLandscape = function()
{
    return Config.MobileDevice &&  Config.ORIENTATION === Config.LANDSCAPE;
};

Config.isPortrait = function()
{
    return Config.MobileDevice &&  Config.ORIENTATION === Config.PORTRAIT;
};

const query = Utils.queryParse();

Config.locale = (query.userLocale || query.locale || 'en').split('_').shift();
Config.debug = (+query.debugMode === 1);
console.info('Config.debug', Config.debug);

Config.LOBBY_URL = query.lobbyURL;

Config.DEFAULT_FONT = 'Helvetica';
Config.DEFAULT_FONT_SIZE = 20;

Config.savedData = null;

Config.devVersion = require('fs').readFileSync('www/js/version.log').toString();
console.info('Config.devVersion', Config.devVersion);

// Init data receiver from Leander on start game
Config.initData = null;

export default Config;